import {hasPath, path} from 'ramda';

export const validateValue = (_path, contextValue, functionString) => {
    const verifiedPath = Array.isArray(_path) ? _path : [_path];
    if (!hasPath(verifiedPath, contextValue)) {
        throw new Error(
            `${functionString} tried to access a path (${_path}) that does not exist ` +
                `in the context value object. Make sure you are using ` +
                `a valid path.`
        );
    }

    return path(verifiedPath, contextValue);
};


export const getWindowContext = () => {
    return !window.__dashprivate_embedded_context
        ? null
        : window.__dashprivate_embedded_context.context;
}
